export default __webpack_public_path__ + "static/media/reda.0f65e93f.png";